import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import Waypoint from 'react-waypoint';

//import BounceSpinner from "./Widgets/BounceSpinner"
import Spinner from "./Widgets/Spinner"

import {loadMoreArticles} from "../actions"
import {isLoadingMore, hasMorePages} from "../selectors"

class InfiniteScrollWaypoint extends PureComponent {

    _handleLoadMore = () => {
        const {handleLoadMore, isLoading} = this.props;
        if(isLoading) return;
        handleLoadMore();
    }

    render() {

        const {classes, isLoading, hasMore} = this.props;

        return <div>
            {hasMore && <Waypoint bottomOffset={-400} onEnter={this._handleLoadMore} />}
            <section className={classes.loadingContainer}>
                {!hasMore && <div>THE END</div>}
                <Spinner show={isLoading} />
            </section>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: isLoadingMore(state),
        hasMore: hasMorePages(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleLoadMore: () => {
            dispatch(loadMoreArticles())
        }
    }
}

export const StyledInifinateScrollWaypoint = injectSheet( (theme) => ({
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        ...theme.font.link,
    },

}))(InfiniteScrollWaypoint);

export default connect(mapStateToProps, mapDispatchToProps)(StyledInifinateScrollWaypoint);



// WEBPACK FOOTER //
// ./src/components/InfiniteScrollWaypoint.js